const useTimeoutList = () => {
  let timeoutList: number[] = [];

  const addTimeout = (func: TimerHandler, milliseconds: number) => {
    timeoutList.push(setTimeout(func, milliseconds));
  };

  const cancelAll = () => {
    timeoutList.forEach((timeout) => {
      clearTimeout(timeout);
    });
    timeoutList = [];
  };

  return {
    addTimeout,
    cancelAll,
  };
};

export default useTimeoutList;
